import { render, staticRenderFns } from "./EndOfPublication.vue?vue&type=template&id=66a52b05&scoped=true&"
import script from "./EndOfPublication.vue?vue&type=script&lang=js&"
export * from "./EndOfPublication.vue?vue&type=script&lang=js&"
import style0 from "./EndOfPublication.vue?vue&type=style&index=0&id=66a52b05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a52b05",
  null
  
)

export default component.exports